export default "__VITE_ASSET__BZVTxdkv__"